import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listFaqDetails } from "../actions/faqActions";
import DashHeader from "./DashHeader";
import ReactMarkdown from "react-markdown";
import { LinkContainer } from "react-router-bootstrap";
import { Helmet } from "react-helmet-async";

function FAQ() {
  let param = useParams();

  const dispatch = useDispatch();
  const faqDetails = useSelector((state) => state.faqDetails);
  const { faq } = faqDetails;

  useEffect(() => {
    dispatch(listFaqDetails(param.id));
  }, [dispatch, param.id]);

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      {/* Meta tags */}
    <Helmet>
      <title>{'Legal FAQ -'+faq?.title}</title>
        <meta name="description" content={faq?.content}/>
        <link rel="canonical" href={"/dashboard/legal-products/intro/"+faq?.id}/>
      </Helmet>
      <DashHeader pageTitle={"FAQ"} />
        <Row className="dashboard-content-container faq-container">
          <Row className="mt-5">
              <Col>
              <LinkContainer to={`/dashboard/faqs`}>
                <button className="lcn-button-orange px-3">Back</button>
                </LinkContainer>
              </Col>
              <Col></Col>
          </Row>
          <div className="faq-content-parent p-5 m-4">
        <Row align="center">
          <h2 className="ll-subtitle ll-feat-font">{faq.title} </h2>
        </Row>
          {/* <Row> {faq.title}</Row> */}
          <Row className="my-3 lac-faq-parent">
            <ReactMarkdown>{faq.content}</ReactMarkdown>
          </Row>
          </div>
        </Row>
    </Col>
  );
}

export default FAQ;
